export const environment = {
  production: true,
  buildId: '3111165937720671',
  configFile: 'config.json',
};
